require("./t-static.scss");


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/template/t-static/t-static.chunk.js